import React, { forwardRef, useCallback } from "react";
import { Link as RRLink, NavLink as RRNavLink, useNavigate as useRRNavigate } from "react-router-dom";
import { getCurrentLang, stripLang, withLang } from "./LanguageContext";

// Language-aware drop-ins for react-router's Link / NavLink / useNavigate:
// internal paths follow the language of the page currently shown.
export const localizeTo = (to) => {
  if (typeof to === "string") {
    if (!to.startsWith("/") || to.startsWith("/api") || to.startsWith("//")) return to;
    const cut = to.search(/[?#]/);
    const path = cut === -1 ? to : to.slice(0, cut);
    const rest = cut === -1 ? "" : to.slice(cut);
    return withLang(stripLang(path), getCurrentLang()) + rest;
  }
  if (to && typeof to === "object" && typeof to.pathname === "string") return { ...to, pathname: localizeTo(to.pathname) };
  return to;
};

export const Link = forwardRef(({ to, ...props }, ref) => <RRLink ref={ref} to={localizeTo(to)} {...props} />);
export const NavLink = forwardRef(({ to, ...props }, ref) => <RRNavLink ref={ref} to={localizeTo(to)} {...props} />);

export function useNavigate() {
  const navigate = useRRNavigate();
  return useCallback((to, options) => (typeof to === "number" ? navigate(to) : navigate(localizeTo(to), options)), [navigate]);
}
